import React from "react";
import HeroSm from "../../components/HeroSm/HeroSm";
import Section from "../../components/Section/Section";
import MainLayout from "../../layouts/MainLayout";
import ImageCardBox from "../../components/ListitemForSaleComponents/ImageCardBox";
import ButtonSelection from "../../components/ListitemForSaleComponents/ButtonSelection";

const ListitemForSale = () => {
    return (
        <MainLayout>
            <HeroSm title="List Item For Sale" />

            <Section id="listitemforsale">
                <div className="listitemforsale-wrap">
                    <h5>Preview :</h5>
                    <ImageCardBox/>
                    <h5 className="my-5">Type :</h5>
                    <ButtonSelection/>
                </div>
            </Section>
        </MainLayout>
    );
};

export default ListitemForSale;
